const defaultData = [
    {
        id: 1,
        thumbnail: 'https://placehold.co/50x50',
        title: 'Neck Pain Treatment',
        doctor: 'Dr. Prasant Sharma',
        date: '2023-01-15',
        details: 'Paracetamol, Ibuprofen, Physical Therapy',
        description: 'The patient underwent a series of physical therapy sessions and was prescribed pain relievers to manage the neck pain.',
        detailedImage: 'https://placehold.co/200x200'
    },
    {
        id: 2,
        thumbnail: 'https://placehold.co/50x50',
        title: 'Knee Surgery',
        doctor: 'Dr. Anjali Mehta',
        date: '2022-11-05',
        details: 'Surgery, Post-op Care, Pain Management',
        description: 'The knee surgery was successful, and the patient is now undergoing rehabilitation exercises to regain full mobility.',
        detailedImage: 'https://placehold.co/200x200'
    },
    {
        id: 3,
        thumbnail: 'https://placehold.co/50x50',
        title: 'Diabetes Management',
        doctor: 'Dr. Rajesh Gupta',
        date: '2022-08-22',
        details: 'Metformin, Diet Control, Regular Check-ups',
        description: 'The patient is being monitored regularly to ensure their blood sugar levels are stable. Medication and lifestyle changes have been recommended.',
        detailedImage: 'https://placehold.co/200x200'
    },
    {
        id: 4,
        thumbnail: 'https://placehold.co/50x50',
        title: 'Heart Surgery',
        doctor: 'Dr. Sunita Kapoor',
        date: '2021-12-10',
        details: 'Bypass Surgery, Post-op Care, Cardiac Rehab',
        description: 'The patient underwent bypass surgery and is currently in the cardiac rehabilitation phase, focusing on a heart-healthy lifestyle.',
        detailedImage: 'https://placehold.co/200x200'
    },
];

export default defaultData;